/* dcl-cart-savings.js (rev 2, 2026-09-25)
 * Dialed Cycling Lab. Replaces Alpha Sale's cart "Your savings" widget.
 *
 * Shows the regular (compare-at) price and the total sale savings above the
 * "Estimated total" line, on the cart page AND in the cart drawer, whenever the
 * cart holds a marked-down item. Hidden when nothing in the cart is on sale.
 *
 * Savings = sum over lines of (compare-at - price) x quantity, using the
 * variant's compare-at from /products/<handle>.js (cart.js does not carry it).
 * Loaded on every page from theme.liquid because the drawer can open anywhere.
 */
(function () {
  'use strict';
  if (window.__dclCartSavings) return;
  window.__dclCartSavings = true;

  var productCache = {};
  var state = null; // { regular, savings } in cents
  var busy = false;
  var timer = null;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function product(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  var again = false;

  function compute() {
    if (busy) { again = true; return; }
    busy = true;
    again = false;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return Promise.all(cart.items.map(function (it) {
          return product(it.handle).then(function (p) {
            if (!p) return { regular: it.price * it.quantity, save: 0 };
            var v = (p.variants || []).filter(function (x) { return x.id === it.variant_id; })[0];
            var cmp = v && v.compare_at_price ? v.compare_at_price : 0;
            var save = cmp > it.price ? (cmp - it.price) * it.quantity : 0;
            return { regular: (cmp > it.price ? cmp : it.price) * it.quantity, save: save };
          });
        }));
      })
      .then(function (rows) {
        var regular = 0, savings = 0;
        rows.forEach(function (r) { regular += r.regular; savings += r.save; });
        state = { regular: regular, savings: savings };
        render();
      })
      .catch(function () { /* leave the cart as the theme drew it */ })
      .then(function () { busy = false; if (again) compute(); });
  }

  function blockHtml() {
    return '<div class="dcl-savings__row"><span>Regular price</span><s>' + money(state.regular) + '</s></div>' +
      '<div class="dcl-savings__row dcl-savings__row--save"><span>Your sale savings</span><strong>&minus;' + money(state.savings) + '</strong></div>';
  }

  var lastTotals = null;

  function render() {
    var totals = document.querySelectorAll('.cart__footer--subtotal .totals, cart-drawer .totals');
    // The theme redraws its total after every cart change, however it made the
    // change. A new total means the savings need recounting.
    var key = Array.prototype.map.call(totals, function (t) { return t.textContent; }).join('|');
    if (lastTotals !== null && key !== lastTotals) { lastTotals = key; compute(); return; }
    lastTotals = key;
    Array.prototype.forEach.call(totals, function (t) {
      var host = t.parentNode;
      var el = host.querySelector(':scope > .dcl-savings');
      if (!state || state.savings <= 0) {
        if (el) el.remove();
        return;
      }
      var html = blockHtml();
      if (!el) {
        el = document.createElement('div');
        el.className = 'dcl-savings';
        host.insertBefore(el, t);
      }
      if (el.innerHTML !== html) el.innerHTML = html;
    });
  }

  function schedule(recompute) {
    clearTimeout(timer);
    timer = setTimeout(function () { recompute ? compute() : render(); }, 250);
  }

  // Recompute after any cart change the theme makes through fetch.
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { schedule(true); }).catch(function () {});
    }
    return p;
  };

  // The theme re-draws the cart footer after changes; put the block back.
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var n = muts[i].target;
      if (n.closest && n.closest('.dcl-savings')) continue;
      schedule(false);
      return;
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  var css = document.createElement('style');
  css.textContent =
    '.dcl-savings{display:grid;gap:6px;padding:12px 14px;margin-bottom:4px;background:#000;color:#fff;' +
    'font-weight:700;text-transform:uppercase;letter-spacing:.04em;font-size:13px;border-left:4px solid #E42E0F}' +
    '.dcl-savings__row{display:flex;justify-content:space-between;align-items:baseline;gap:12px}' +
    '.dcl-savings__row s{opacity:.7;font-weight:600}' +
    '.dcl-savings__row--save{color:#fff}.dcl-savings__row--save strong{color:#E42F0F;font-size:15px}';
  document.head.appendChild(css);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', compute);
  else compute();
})();
